module.exports = __webpack_public_path__ + "img/10.53de8743.jpg";